<template>
  <div>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-form :model="addForm" ref="addFormRef" :inline="true" label-width="80px" class="font-bold">
        <el-form-item label="客户id" prop="uid" >
          <el-input size="small" v-model="addForm.uid" clearable placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="客服id" prop="cid" >
          <el-input size="small" v-model="addForm.cid" clearable placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="时间区间" prop="dateValue" >
          <el-date-picker
            v-model="addForm.dateValue"
            size="small"
            type="datetimerange"
            :picker-options="pickerOptions"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="dateRangeChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="getevaluateList(true)">搜索</el-button>
          <el-button size="small" @click="resetInput">重置</el-button>
        </el-form-item>

      </el-form>

      <el-table :data="evaluate" border stripe>
        <el-table-column label="编号" type="index"></el-table-column>
        <el-table-column label="客户id" prop="Uid" width="200%"></el-table-column>
        <el-table-column label="客服id" prop="Cid" width="80%"></el-table-column>
        <el-table-column label="评价内容" prop="Content"></el-table-column>
        <el-table-column label="服务时间" prop="WorkHours"></el-table-column>
        <el-table-column label="评分" prop="Score"></el-table-column>
        <el-table-column label="开始时间" prop="StartAt" width="180%"></el-table-column>
        <el-table-column label="结束时间" prop="EndAt" width="180%"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum" :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
  import { chat_get } from '@/api'
  import {formatDate} from '@/utils'

  export default {
    name: 'Evaluate',
    data() {
      return {
        // 获取角色列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          pagenum: 1,
          // 当前每页显示多少条数据
          pagesize: 10
        },
        evaluate: [],
        total: 0,
        addForm: {
          uid: '',
          cid: '',
          status: '',
          startTime: '',
          endTime: '',
          dateValue: []
        },
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    created() {
      this.getevaluateList()
    },
    methods: {
      getevaluateList(val = false) {
        if (val) this.queryInfo.pagenum = 1;
        let { uid, cid, status, startTime, endTime } = this.addForm;
        chat_get(`/admin/v1/evalDetailList?size=${this.queryInfo.pagesize}&page=${this.queryInfo.pagenum}&uid=${uid}&cid=${cid}&status=${status}&created_start_at=${startTime}&created_end_at=${endTime}`, {}, res => {
          if (res.status == 200) {
            let { Count, EvaluationRecord } = res.data
            this.total = Count;
            if(!EvaluationRecord) this.evaluate = []
            EvaluationRecord.forEach(item => {
              item.Content = item.Content || '空'
              item.StartAt = formatDate(item.StartAt * 1000)
              item.EndAt = formatDate(item.EndAt * 1000)
            })
            this.evaluate = EvaluationRecord;
          }
        })
      },
      // 监听 pagesize 改变的事件
      handleSizeChange(newSize) {
        this.queryInfo.pagesize = newSize
        this.getevaluateList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange(newPage) {
        this.queryInfo.pagenum = newPage
        this.getevaluateList()
      },
      resetInput() {
        this.$refs.addFormRef.resetFields()
        this.getevaluateList()
      },
      dateRangeChange() {
        this.addForm.startTime = this.addForm.dateValue ? this.addForm.dateValue[0] : ''
        this.addForm.endTime = this.addForm.dateValue ? this.addForm.dateValue[1] : ''
      },
    }
  }
</script>

<style scoped>
  .el-icon-circle-close {
    color: white !important;
  }
</style>
